// @file Surface Panels store.
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSurfacePanelsStore = defineStore('surfacePanelsStore', () => {
  // State
  const xSurfaceDetailsPanel = ref(false)

  return {
    // State
    xSurfaceDetailsPanel,
  }
})
